import { Injectable } from '@angular/core';
import { Headers, URLSearchParams } from '@angular/http';

import { LoginInputModel, ForgetInputModel } from '../models/login.model'
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class SigninService {
    constructor(
        private httpService: HttpService) { }

    // 立即注册
    register() {
        var url = AppConfig.GetProdUrl() + "/System/GetOpenRegister";
        return this.httpService.get(url);
    }
    //用户登录
    //TQQ 2016-12-23
    login(user: LoginInputModel) {
        let myHeader = new Headers();
        myHeader.append('Content-Type', 'application/x-www-form-urlencoded');
        var url = AppConfig.GetProdUrl() + "/token";
        let params = new URLSearchParams();
        for (var key in user) {
            if (user.hasOwnProperty(key)) {
                var element = user[key];
                params.append(key, element);
            }
        }
        params.append("grant_type", "password");
        params.append("client_id", "legend");
        return this.httpService.post(url, params.toString(), { headers: myHeader });
    }

    //根据tocken获取用户信息
    //TQQ 2016-12-29
    getUserModel() {
        var url = AppConfig.GetProdUrl() + "/User/GetUserModel";
        return this.httpService.get(url);
    }
    /**
 * 获取文字验证图片
 * evan 2020-03-16 
 * @returns 获取验证base64 的图片
 * @memberof SigninService
 */
    getVerificationCodeImage(params) {
        var url = AppConfig.GetProdUrl() + "/Auth/VerificationCodeImage";
        return this.httpService.get(url, params)
    }

    /**
     * 根据参数验证
     * evan 2020-03-16 
     * @returns 获取验证base64 的图片
     * @memberof SigninService
     */
    postVerificationCheck(params) {
        let myHeader = new Headers();
        myHeader.append('Content-Type', 'application/x-www-form-urlencoded');
        var url = AppConfig.GetProdUrl() + "/Auth/VerificationCheck";
        return this.httpService.post(url, params.toString(), { headers: myHeader });
    }

    //谷歌登录器验证
    //TQQ 2017-01-16
    // varifyGakey(user) {
    //     var url = AppConfig.GetProdUrl() + "/auth/VarifyGakey";
    //     return this.httpService.post(url, user);
    // }

    //忘记密码
    //TQQ 2017-05-15
    forgetPwdck(params) {
        var url = AppConfig.GetProdUrl() + "/log/forgetPwdck";
        return this.httpService.post(url, params);
    }

    //验证密保问题
    //TQQ 2017-05-15
    ckUserQuestion(params: ForgetInputModel) {
        var url = AppConfig.GetProdUrl() + "/log/ckUserQuestion";
        return this.httpService.post(url, params);
    }

    //重置密码
    //TQQ 2017-05-15
    reLoginPwd(params: ForgetInputModel) {
        var url = AppConfig.GetProdUrl() + "/log/reLoginPwd";
        return this.httpService.post(url, params);
    }
    //密码是否校验过于简单
    IsCkSimplePwd(params) {
        var url = AppConfig.GetProdUrl() + "/User/IsCkSimplePwd";
        return this.httpService.get(url, params);
    }
}




// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/services/signin.service.ts